export const Type = {
    START_NAP: 'START_NAP',
    END_NAP: 'END_NAP',
};
